<template>
  <div>
    <form @submit.prevent="send">
      <div>

        <div class="">
          <div class="card-content">
            <div class="content">
              <div class="field is-horizontal">
                <div class="field-body">
                  <div class="field">
                    <label class="label"
                           v-bind:class="[ errors.has('gender') ? 'has-text-danger' : '']">{{
                        $t('candidate.contact.sex.label')
                      }}</label>
                    <div class="radio-group">
                      <label>
                        <input type="radio" name="gender" v-validate="'required|in:M,F'"
                               :value="'M'"
                               v-model="candidate.gender">
                        <div class="choice">
                          <span>{{ $t('candidate.contact.sex.male') }}</span>
                        </div>
                      </label>
                      <label>
                        <input type="radio" name="gender" :value="'F'"
                               v-model="candidate.gender">
                        <div class="choice">
                          <span>{{ $t('candidate.contact.sex.female') }}</span>
                        </div>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="field is-horizontal">
                <div class="field-body">
                  <div class="field">
                    <p class="control is-expanded">
                      <b-field label="Prenom" class="has-text-left">
                        <b-input v-model="candidate.first_name"
                                 minlength="1"
                                 required>

                        </b-input>
                      </b-field>
                    </p>
                  </div>
                  <div class="field">
                    <p class="control is-expanded">
                      <b-field label="Nom" class="has-text-left">
                        <b-input v-model="candidate.last_name"
                                 minlength="1"
                                 required>

                        </b-input>
                      </b-field>
                    </p>
                  </div>
                </div>
              </div>
              <div class="field is-horizontal">
                <div class="field-body">
                  <div class="field">
                    <p class="control is-expanded">
                      <b-field :label="$t('candidate.contact.birthday')" class="has-text-left">
                        <b-input type="text"
                                 placeholder="JJ/MM/AAAA"
                                 name="birthday"
                                 required
                                 v-cleave="masks.date"
                                 v-model="date">

                        </b-input>
                      </b-field>
                    </p>
                  </div>
                  <div class="field">
                    <p class="control is-expanded">
                      <b-field :label="$t('candidate.contact.birth_place')" class="has-text-left">
                        <b-input
                            type="text"
                            name="birthplace"
                            required
                            v-model="candidate.birth_place">
                        </b-input>
                      </b-field>
                    </p>
                  </div>
                </div>
              </div>
              <div class="field is-horizontal">
                <div class="field-body">
                  <div class="field">
                    <b-field :label="$t('candidate.contact.nationality')">
                      <b-select placeholder="---" v-model="candidate.nationality" required>
                        <option value="">---</option>
                        <option
                            v-for="country in countries"
                            :value="country['alpha-2']"
                        >
                          {{ country.nationality }}
                        </option>
                      </b-select>
                    </b-field>
                  </div>
                  <div class="field">
                    <b-field :label="$t('candidate.contact.second_nationality')">
                      <b-select placeholder="---" v-model="candidate.second_nationality">

                        <option value="">---</option>
                        <option
                            v-for="country in countries"
                            :value="country['alpha-2']"
                        >
                          {{ country.nationality }}
                        </option>
                      </b-select>
                    </b-field>
                  </div>
                </div>
              </div>
              <div class="field is-horizontal">
                <div class="field-body">
                  <div class="field">
                    <p class="control is-expanded">

                      <b-field :label="$t('candidate.contact.passport_number')" class="has-text-left">
                        <b-input
                            type="text"
                            name="passport_number"
                            v-model="candidate.passport_number">
                        </b-input>
                      </b-field>

                    </p>
                  </div>
                  <div class="field">
                    <p class="control is-expanded" v-if="candidate.passport_number">

                      <b-field :label="$t('candidate.contact.passport_validity')" class="has-text-left">
                        <b-input type="text"
                                 placeholder="JJ/MM/AAAA"
                                 name="passport_validity"
                                 required
                                 v-cleave="masks.date"
                                 v-model="candidate.passport_validity">
                        </b-input>
                      </b-field>
                    </p>
                  </div>
                </div>
              </div>
              <div class="field is-horizontal">
                <div class="field-body">
                  <div class="field">
                    <p class="control is-expanded">
                      <b-field :label="$t('candidate.contact.native_language')" class="has-text-left">
                        <b-input type="text"
                                 name="native_language"
                                 v-model="candidate.native_language">
                        </b-input>
                      </b-field>
                    </p>
                  </div>
                  <div class="field">
                    <p class="control is-expanded">

                      <b-field :label="$t('candidate.contact.siblings')" class="has-text-left">
                        <b-input type="number"
                                 name="siblings"
                                 min="0"
                                 v-model="candidate.siblings">
                        </b-input>
                      </b-field>
                    </p>
                  </div>
                </div>
              </div>
              <div class="field">
                <div class="field-body">
                  <div class="field">
                    <b-field :label="$t('shop.candidates.medical')">

                      <div class="block">
                        <b-radio v-model="candidate.motivationFields.medical"
                                 required
                                 name="medical"
                                 native-value="true">
                          {{ $t('labels.general.yes') }}
                        </b-radio>
                        <b-radio v-model="candidate.motivationFields.medical"
                                 name="medical"
                                 native-value="false">
                          {{ $t('labels.general.no') }}
                        </b-radio>
                      </div>
                    </b-field>
                    <b-field :label="$t('candidate.motivations.school.yes_response')"
                             v-if="candidate.motivationFields.medical === 'true'" custom-class="p-t-md">
                      <b-input maxlength="200" type="textarea" v-model="candidate.motivationFields.medical_text"
                               required></b-input>
                    </b-field>

                  </div>
                </div>

              </div>
              <div class="field">
                <b-field :label="$t('shop.candidates.diet')" custom-class="">

                  <div class="block">
                    <b-radio v-model="candidate.motivationFields.diet"
                             required
                             name="diet"
                             native-value="true">
                      {{ $t('labels.general.yes') }}
                    </b-radio>
                    <b-radio v-model="candidate.motivationFields.diet"
                             name="diet"
                             native-value="false">
                      {{ $t('labels.general.no') }}
                    </b-radio>
                  </div>
                </b-field>
                <b-field :label="$t('candidate.motivations.school.yes_response')"
                         v-if="candidate.motivationFields.diet === 'true'" custom-class="p-t-md">
                  <b-input maxlength="200" type="textarea" v-model="candidate.motivationFields.diet_text"
                           required></b-input>
                </b-field>
              </div>
            </div>
          </div>
        </div>

      </div>

      <hr>
      <div class="has-text-centered">
        <button :class="'is-large button-valid button ' + isLoading">
          {{ $t('shop.cart.register_child') }}
        </button>
        <br>
        <br>
        <transition name="slide-fade">
          <div class="has-text-danger has-text-centered">{{ errorMsg }}</div>
        </transition>
      </div>
    </form>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import moment from 'moment/moment'
import Cleave from '../../../../../../node_modules/cleave.js/dist/cleave'
import CountriesFR from '../../../utils/countries_fr.json'

const cleave = {
  name: 'cleave',
  bind(el, binding) {
    const input = el.querySelector('input')
    input._vCleave = new Cleave(input, binding.value)
  },
  update(el, binding) {
    const input = el.querySelector('input')
    input._vCleave.destroy()
    input._vCleave = new Cleave(input, binding.value)
  },
  unbind(el) {
    const input = el.querySelector('input')
    input._vCleave.destroy()
  }
}

export default {
  directives: {cleave},
  data() {
    return {
      isLoading: '',
      date: null,
      passport_validity: null,
      candidate: {
        profile_photo: '',
        gender: '',
        first_name: '',
        last_name: '',
        birthday: '',
        birth_place: '',
        nationality: '',
        second_nationality: '',
        passport_number: '',
        passport_validity: '',
        native_language: '',
        siblings: '',
        motivationFields: {
          reference: '',
          bac: '',
          medical: '',
          diet: '',
          internship: '',
          personality: '',
          school_internship: '',
          sports: [
            {
              name: '',
              level: '',
              pro: '',
              years: ''
            }
          ],
          musics: [
            {
              name: '',
              level: '',
              years: ''
            }
          ],
          other_activity: ''
        },
      },

      masks: {
        phone: {
          phone: true,
          phoneRegionCode: 'FR'
        },
        date: {
          date: true,
          datePattern: ['d', 'm', 'Y']
        }
      },
      countries: null,
      errorMsg: '',
      errorImg: ''
    }
  },

  props: {
    school: {type: Object}
  },
  computed: {
    ...mapGetters({
      status: 'candidate/getStatus',
      isLoggedIn: 'auth/isLoggedIn',
      account: 'auth/getAccount'
    })
  },
  methods: {
    ...mapActions('candidate', [
      'addShopCandidate'
    ]),
    toggleLoading: function () {
      this.isLoading = (this.isLoading === '') ? 'is-loading' : ''
    },
    send: function () {

      this.$validator.validateAll().then((result) => {
        if (result) {

          this.toggleLoading()
          this.candidate.profile_photo = this.profile_photo
          this.candidate.user = this.account
          if (this.candidate.passport_number) {
            if (moment(this.candidate.passport_validity, 'DD/MM/YYYY').isValid()) {
              this.candidate.passport_validity = moment(this.candidate.passport_validity, 'DD/MM/YYYY').format('YYYY-MM-DD');
            } else {

              this.toggleLoading()
              this.errorMsg = this.$t('candidate.contact.validation.passport')
              setTimeout(() => {
                this.errorMsg = ''
              }, 1500)
              return

            }
          }

          if (this.date && moment(this.date, 'DD/MM/YYYY').isValid()) {
            this.candidate.birthday = moment(this.date, 'DD/MM/YYYY').format('YYYY-MM-DD');
          } else {

            this.toggleLoading()
            this.errorMsg = this.$t('candidate.contact.validation.birthday')
            setTimeout(() => {
              this.errorMsg = ''
            }, 1500)
            return

          }

          this.addShopCandidate(this.candidate).then((result) => {
            switch (this.status) {
              case 200:
                this.toggleLoading()
                this.$emit('send')

                break
              case 403:
                this.toggleLoading()
                this.$emit('notAuthenticated')
                break
              case 422:
                this.toggleLoading()
                this.errorMsg = this.$t('candidate.contact.validation.email')
                break
              default:
                this.toggleLoading()
                this.errorMsg = this.$t('candidate.general.unknown')
            }
          }).catch((err) => {
            this.toggleLoading()
            this.error = err.message
          })

        } else {
          this.errorMsg = this.$t('candidate.contact.validation.empty_field')
          setTimeout(() => {
            this.errorMsg = ''
          }, 1500)
        }
      })
    }

  },
  created() {
    if (this.candidate.birthday) {
      this.date = moment(new Date(this.candidate.birthday)).format('DD/MM/YYYY');
    }
    if (this.candidate.passport_validity) {
      this.passport_validity = moment(new Date(this.candidate.passport_validity)).format('DD/MM/YYYY');
    }

    this.countries = CountriesFR
  }
}
</script>
<style scoped>
.b-radio.radio .control-label {
  padding-left: 0.2em;
}
</style>
